/** Calendar dates (YYYY-MM-DD) in UK time, matching the API's notion of "today". */
export const BUSINESS_TIMEZONE = "Europe/London";

export function todayInLondon(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: BUSINESS_TIMEZONE }).format(new Date());
}

export function addDays(isoDate: string, days: number): string {
  const d = new Date(`${isoDate}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

const dayFmt = new Intl.DateTimeFormat("en-GB", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });

/** The UK calendar date of a moment, e.g. "2026-10-12". */
export function londonDate(timestamp: string): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: BUSINESS_TIMEZONE }).format(new Date(timestamp));
}

const pastFmt = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });

/** When something last happened, for running text: "today", "yesterday", "Mon 12 Oct", or "3 Feb 2025" if over a year ago. */
export function whenLast(timestamp: string, today = todayInLondon()): string {
  const day = londonDate(timestamp);
  if (day === today) return "today";
  if (day === addDays(today, -1)) return "yesterday";
  if (day < addDays(today, -300)) return pastFmt.format(new Date(`${day}T12:00:00Z`));
  return dayFmt.format(new Date(`${day}T12:00:00Z`));
}

/** "Today", "Tomorrow", "Yesterday", or e.g. "Mon 12 Oct". */
export function friendlyDate(isoDate: string, today = todayInLondon()): string {
  if (isoDate === today) return "Today";
  if (isoDate === addDays(today, 1)) return "Tomorrow";
  if (isoDate === addDays(today, -1)) return "Yesterday";
  return dayFmt.format(new Date(`${isoDate}T12:00:00Z`));
}
